import { EmailExchanges } from "@/components/email-exchanges.jsx";

const Emails = () => {
  return (
    <div className="p-6">
      <EmailExchanges />
    </div>
  );
};

export default Emails;
